import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { theme } from '../../styled/theme'
import { HelpText } from '../../components/server-settings/form-components/help-text'
import {
  Link,
  LinkProps
} from '@contrast-security-inc/design-system-typography'

const linkProps: LinkProps = {
  color: 'turquoise90',
  font: 'metadata',
  isExternal: true,
  className: css`
    margin-top: 8px;
  `
}

export function BasicTooltipContent({
  i18nTitle,
  i18nDescription,
  i18nLinkText = 'detail_overallApplicationLearnMoreLink',
  linkUrl
}: {
  i18nTitle: string
  i18nDescription: string
  i18nLinkText?: string
  linkUrl?: string
}) {
  const { formatMessage } = useIntl()

  return (
    <>
      <p
        className={css`
          font-weight: ${theme.fontWeights.secondary.boldest};
        `}
      >
        {formatMessage({ id: i18nTitle })}
      </p>

      <HelpText>{formatMessage({ id: i18nDescription })}</HelpText>

      {linkUrl && (
        <Link href={linkUrl} {...linkProps}>
          {formatMessage({ id: i18nLinkText })}
        </Link>
      )}
    </>
  )
}
